//
//
//
//
//
//
//
//
//
//

import Footer from '@/components/Footer.vue'

export default {
  name: 'NoSidebar',
  components: {
    'postpone-footer': Footer
  }
}
